import useHomeService from '@/hooks/useHomeService'
import FaqContent from '@/components/common/FaqContent'
import FaqAndInfo from '@/components/dashboard/FaqAndInfo'

const Faq = () => {
  const { data, isLoading } = useHomeService()
  return (
    <>
      <div className="w-full md:w-2/3 lg:w-2/3 uta-container md:min-h-[calc(100vh-330px)]">
        <div className="w-full mt-20 mb-8">
          <FaqContent data={data} isLoading={isLoading} />
        </div>
      </div>
      <FaqAndInfo />
    </>
  )
}
export default Faq
